module.exports = __webpack_public_path__ + "img/other-es.0455dea.webp";